import React, { FC } from 'react';
import {
  List,
  shifts,
  Spacing,
  Tabs,
  Typography,
} from '@taleemabad/dsm/components';
import styled from '@emotion/styled';
import { ISchoolClassInfo } from '@taleemabad/db';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

interface ExamGeneratorAssignedClassesProps {
  activeTab: number;
  handleTabChange: (value: number) => void;
  filteredClasses: ISchoolClassInfo[];
  handleGradeSelection: (item: ISchoolClassInfo) => void;
  loadingComponent: () => React.ReactNode;
}

export const ExamGeneratorAssignedClassesTemplate: FC<
  ExamGeneratorAssignedClassesProps
> = ({
  activeTab = 1,
  handleTabChange,
  filteredClasses,
  handleGradeSelection,
  loadingComponent,
}) => {
  return (
    <>
      <Spacing marginBottom="xxl">
        <Tabs
          variant="secondary"
          activeTabKey={activeTab}
          tabs={shifts}
          onChange={(value: number) => handleTabChange(value)}
        />
      </Spacing>
      {filteredClasses?.length !== 0 ? (
        <>
          <Typography
            variant="textTitleMediumSurfaceVariant"
            data-cy="assigned-grades-title"
          >
            Assigned Grades
          </Typography>
          <Spacing marginTop="lg">
            <Typography variant="textTitleLarge">
              Select a grade to generate exam
            </Typography>
          </Spacing>
        </>
      ) : (
        <Typography variant="textTitleLarge">No assigned classes</Typography>
      )}
      <Spacing margin="xl" />
      <ListContainer>
        <ClassContainer>
          {filteredClasses &&
            filteredClasses.length > 0 &&
            filteredClasses.map((item) => (
              <List
                key={`${item.id}`}
                alignment="center"
                heading={`${item.gradeLabel} - ${item.section}  ${item.subjectLabel}`}
                onClick={() => handleGradeSelection(item)}
                trailingIcon={{
                  direction: 'trailing',
                  source: 'keyboard_arrow_right',
                  name: 'keyboard_arrow_right',
                  type: 'icon',
                }}
              />
            ))}
        </ClassContainer>
        {loadingComponent()}
      </ListContainer>
    </>
  );
};

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 524px;
  row-gap: var(--rk-spacing-xxxxxxxxxxxxxxxxxl);
  margin-top: var(--rk-spacing-xxxl);
  ${mq(BreakpointSizes.xs)} {
    justify-content: space-between;
    row-gap: var(--rk-spacing-md);
    margin-bottom: var(--rk-spacing-xxxxl);
  }
`;

const ClassContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--rk-spacing-md);
`;
